module.exports = __webpack_public_path__ + "img/img_hezuo_5@2x.03b84243.png";